var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navigation-overlay',{staticClass:"nav-bar-root",attrs:{"isOpen":_vm.isOpen},on:{"close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }